/**
 * Tutorial Page
 * Onboarding tutorial screen shown before authentication (first-time users)
 * Accessible without authentication - shown before login/signup
 */

import { TutorialScreen } from '../../components/tutorial/TutorialScreen';
import { ErrorBoundary } from '../../components/layout';

export default function Tutorial() {
  return (
    <ErrorBoundary>
      <TutorialScreen />
    </ErrorBoundary>
  );
}

